import React from 'react';
import { collect } from 'react-recollect';
import { Row, Col, Label } from 'reactstrap';
import { getLangType, getMaskNameColor, getMaskCushionSize, getMaskNumCushionSizes, getMaskFrameSize } from '../utils/utils';
import { languageOptions } from '../language';
import { getProductSKU } from './PatientDetails';
import Select from 'react-select';
import ToolTip from './ToolTip';
import MaskRecommendationRadioButton from './MaskRecommendationRadioButton';
const langType = getLangType();

const RecommendedMaskList = ({ store, maskResultsList, readOnly, isRecommendedMask, setRecommendedMask, isCurrentMask, selectedRecommendationMaskType, setCushionSize, setFrameSize, selectedMaskCushionSize, selectedMaskFrameSize }) => {
  return (
    <>
      {maskResultsList?.map((maskResult, i) => {
        const { product_id, isFitpack, headgearId } = getProductSKU(maskResult)
        return (
          <div className='recommendedMasks-container' key={maskResult.product_id + i + maskResult.name} >
            <small><strong>{maskResult.subtitle}</strong></small>
            <Row
              className={(readOnly || store.selectedRow.voided_at) ?
                'recommendationSelectRowNoHover' : isRecommendedMask(maskResult) ? 'recommendationSelectRow selected' : 'recommendationSelectRow'}
            >
              <Col xl={6} className="mask-info mb-2 mb-xl-0">
                <div className="mask-check">
                  {(!readOnly && !store.selectedRow.voided_at) &&
                    <MaskRecommendationRadioButton
                      maskName={maskResult.name}
                      checked={isRecommendedMask(maskResult)}
                      handleChange={() => setRecommendedMask(maskResult)}
                      color={getMaskNameColor(maskResult.name)}
                    />
                  }
                </div>
                {maskResult.chin_strap && (
                  <Label className="text-secondary font12" style={{ marginLeft: '23px' }}>{languageOptions.canUseChinStrap[langType]}</Label>
                )}
              </Col>
              <Col xl={6}>
                <Row className='justify-content-between mb-1'>
                  <Col lg={5} className='d-flex align-items-center'>
                    {languageOptions.cushionSize[langType]}:&nbsp;<strong>{maskResult.cushion_size}</strong>
                    {maskResult.cushion_size_alternate &&
                      ((getMaskNumCushionSizes(maskResult.name) <= 2 && Math.abs(maskResult.cushion_size_margin) < 5.0) || (getMaskNumCushionSizes(maskResult.name) > 2 && Math.abs(maskResult.cushion_size_margin) < 2.0)) && (
                        <ToolTip
                          id={'cushion-size-alternate-tooltip-' + maskResult.name}
                          content={<span>A size <strong>{maskResult.cushion_size_alternate}</strong> cushion may also be appropriate for this patient</span>}
                          iconType={maskResult.cushion_size_margin > 0 ? 'fa-arrow-alt-circle-down' : 'fa-arrow-alt-circle-up'}
                        />
                      )}
                  </Col>
                  <Col lg={7}>
                    {selectedRecommendationMaskType === maskResult.name &&
                      <Row className='align-items-center'>
                        <Col xs={6} xl={7} className='p-xl-0'>Cushion Change:</Col>
                        <Col xs={6} xl={5} className='p-xl-0'><Select
                          isDisabled={store.selectedRow.voided_at}
                          onChange={(e) => setCushionSize(e)}
                          options={getMaskCushionSize(maskResult.name)}
                          defaultValue={
                            isCurrentMask(maskResult) ?
                              { value: selectedMaskCushionSize, label: selectedMaskCushionSize } :
                              { value: maskResult.cushion_size, label: maskResult.cushion_size }
                          } />
                        </Col>
                      </Row>
                    }
                  </Col>
                </Row>
                <Row className='justify-content-between mb-1'>
                  <Col lg={5} className='d-flex align-items-center'>
                    {languageOptions.frameSize[langType]}:&nbsp;<strong>{maskResult.frame_size}</strong>
                  </Col>
                  <Col lg={7}>
                    {selectedRecommendationMaskType === maskResult.name &&
                      <Row className='align-items-center'>
                        <Col xs={6} xl={7} className='p-xl-0'>Frame Change:</Col>
                        <Col xs={6} xl={5} className='p-xl-0'><Select
                          isDisabled={store.selectedRow.voided_at}
                          options={getMaskFrameSize(maskResult.name)}
                          defaultValue=
                          {isCurrentMask(maskResult) ?
                            { label: selectedMaskFrameSize, value: selectedMaskFrameSize } :
                            { label: maskResult.frame_size, value: maskResult.frame_size }
                          }
                          onChange={(e) => setFrameSize(e)}
                        />
                        </Col>
                      </Row>}
                  </Col>
                </Row>
                <span>
                  {languageOptions.productID[langType]}: <strong>{headgearId ? `${product_id}+${headgearId}` : product_id}</strong>
                  {isFitpack && (
                    <ToolTip
                      id={'fitpack-tooltip-' + maskResult.name}
                      content={<span>This SKU is part of a <strong>FitPack</strong>.</span>}
                      iconType={'fa-info-circle'}
                    />
                  )}
                  {maskResult.name === 'ResMed P10' && (
                    <ToolTip
                      id={'resmed-p10-tooltip-' + maskResult.name}
                      content={<span>If you choose <strong>Pink</strong> or <strong>XS size</strong> use SKU: 62910.</span>}
                      iconType={'fa-info-circle'}
                    />
                  )}
                </span>
              </Col>
            </Row>
          </div>
        )
      })}
    </>
  )
}

export default collect(RecommendedMaskList)